import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useTheme } from '@emotion/react';
import { Breadcrumbs, CircularProgress, LinearProgress, Skeleton, Stack } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useState } from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ErrorIcon from '@mui/icons-material/Error';
import { DataGridPremium, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-premium';
import Dayjs from 'dayjs';
import { hashDiagram } from '../../../utils/Deployer';
import { convertOnePolicyStructure } from '../../../utils/convertPolicyStructure'
import dayjs from 'dayjs';



export default function AddPoliciesDialog(props) {
    const { open, onClose, aaConfig, user } = props;
    const theme = useTheme();
    const iaam = window.iaam;

    const [tabSeleted, setTabSeleted] = useState("project");
    const [loading, setLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [projectSelected, setProjectSelected] = useState(null);
    const [policies, setPolicies] = useState([]);
    const [policySelectionIndex, setPolicySelectionIndex] = useState({
        type: 'include',
        ids: new Set(),
    });
    const [policiesSelected, setPoliciesSelected] = useState([]);
    const [processing, setProcessing] = useState(false);

    const [isUpdatePolicies, setUpdatePolicies] = useState(false);

    const getPolicyStatus = async (policy, policyStore) => {
        const policyFound = policyStore?.[policy.policy_diagram_id];
        if (policyFound) {
            const hash_diagram = await hashDiagram(policy.diagram);
            if (policyFound.hash_diagram === hash_diagram) {
                return "Deployed";
            }
            return "Modified";
        }
        return "New";
    };

    useEffect(() => {
        const fetchAA = async () => {
            setLoading(true)
            try {
                const resp = await fetch(`${process.env.REACT_APP_API_URL}/project/get-projects`);
                if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
                const listProject = await resp.json();
                setProjects(listProject?.projects ? listProject.projects : [])
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.log(error)
            }
        }
        if (open) {
            setUpdatePolicies(false)
            fetchAA();
        }
    }, [open])

    useEffect(() => {

        const initPolicies = async () => {
            try {
                setLoading(true);
                const accessToken = await iaam.getAccessToken();
                let option = {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': `bearer ${accessToken}`
                    }
                }
                let resp = await fetch(`${aaConfig?.get_policies}`, option)
                if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
                let result = await resp.json();
                let list_policy = result.map((item, index) => ({
                    ...item,
                    id: index,
                    created_at: Dayjs(item.created_at).format("YYYY-MM-DD HH:mm:ss"),
                    last_updated: Dayjs(item.last_updated).format("YYYY-MM-DD HH:mm:ss"),
                    deployed_at: Dayjs(item.deployed_at).format("YYYY-MM-DD HH:mm:ss"),
                }));
                let policyStore = {}
                for (const policy of list_policy) {
                    policyStore[`${policy.policy_diagram_id}`] = policy
                }

                resp = await fetch(`${process.env.REACT_APP_API_URL}/policy-diagram/get-policies/${projectSelected.project_id}`);
                if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
                result = await resp.json();
                list_policy = await Promise.all(result.map(async (policy, index) => ({
                    ...policy,
                    id: index,
                    status: await getPolicyStatus(policy, policyStore),
                    created_at: Dayjs(policy.created_at).format("YYYY-MM-DD HH:mm:ss"),
                    last_updated: Dayjs(policy.last_updated).format("YYYY-MM-DD HH:mm:ss"),
                    deployed_at: Dayjs(policy.deployed_at).format("YYYY-MM-DD HH:mm:ss"),
                })));
                setPolicies(list_policy);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        }

        if (tabSeleted === "project") {
            setPolicies([]);
            setPolicySelectionIndex({
                type: 'include',
                ids: new Set(),
            })
        }
        else if (tabSeleted === "policy") {
            initPolicies();
            setPoliciesSelected([]);
        }
    }, [tabSeleted])

    const handleClose = () => {
        onClose(isUpdatePolicies)
        setTabSeleted("project")
        setProjectSelected(null)
        setPolicySelectionIndex({
            type: 'include',
            ids: new Set(),
        })
        setProcessing(false)
    };

    const handleOnSelectProject = (project) => {
        setProjectSelected(project);
        setTabSeleted("policy");
    };

    const columns = [
        {
            field: 'policy_diagram_name',
            headerName: 'Policy Name',
            minWidth: 200,

        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <span
                    className={
                        params.value === "Deployed"
                            ? "text-green-600 font-semibold"
                            : params.value === "Modified"
                                ? "text-yellow-600 font-semibold"
                                : "text-blue-600"
                    }
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: 'created_by',
            headerName: 'Created by',
            width: 200,
        },
        {
            field: 'updated_by',
            headerName: 'Updated by',
            width: 200,
        },
        {
            field: 'created_at',
            headerName: 'Created at',
            width: 180,
        },
        {
            field: 'last_updated',
            headerName: 'Last updated',
            width: 180,
        }

    ];

    const handleOnChoosePolicies = () => {
        const listPolicy = policies.filter((value, idx) => policySelectionIndex.ids.has(idx))
        const policiesSelected = listPolicy.map((policy, idx) => ({
            policy: { ...policy }, status: null, policy_structure: null, deployed_at: null, error: null,
        }))
        // console.log(policiesSelected)
        setPoliciesSelected(policiesSelected)
        setTabSeleted("deployer")
    }

    const getDRG = async (drg_id) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatory/${drg_id}`);
        if (response.ok) {
            const result = await response.json();
            // const changedKeyNameInAuthorizedData = { // แก้ชื่อ key ใน authorized_data จาก attribute_selection เป็น resource_schema เพื่อให้ตรงกับที่ใช้ใน node root
            //     ...result,
            //     diagram: {
            //         ...result.diagram,
            //         nodes: result.diagram.nodes.map(node => {
            //             if (node.data.general_properties.attribute_selection) {
            //                 return {
            //                     ...node,
            //                     data: {
            //                         ...node.data,
            //                         general_properties: {
            //                             ...node.data.general_properties,
            //                             resource_schema: node.data.general_properties.attribute_selection,
            //                             attribute_selection: undefined // ลบ key attribute_selection ออก
            //                         }
            //                     }
            //                 }
            //             } else {
            //                 return node;
            //             }
            //         })
            //     }
            // };
            return result;
        } else {
            console.error(response.status);
        }
    };

    const handleOnDeploy = async () => {
        setProcessing(true)
        //update all policiesSelected status -> processing
        setPoliciesSelected(policiesSelected.map((policy) => ({ ...policy, status: "processing" })))

        for (let index = 0; index < policiesSelected.length; index++) {
            const policyStructure = await convertOnePolicyStructure(policiesSelected[index].policy, user);
            // console.log("policyStructure:", policyStructure);
            const policyDiagram = { project_id: projectSelected.project_id, project_name: projectSelected.project_name, ...policiesSelected[index].policy }
            let drgs = []
            for (const rule of policyStructure.rules) {
                if (rule.resource.type.toUpperCase() === "DATA") {
                    drgs.push(await getDRG(rule?.obligation?.drg_id))
                }
            }

            let updatePoliciesSelected = [...policiesSelected];
            const policy_structure = { ...policyStructure, active: true, hash_diagram: await hashDiagram(policiesSelected[index].policy.diagram) };
            // console.log("policy_structure:", policy_structure);
            const accessToken = await iaam.getAccessToken();
            let option = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${accessToken}`
                },
                body: JSON.stringify({
                    user: user,
                    project_id: projectSelected.project_id,
                    project_name: projectSelected.project_name,
                    policy_structure: policy_structure,
                    policy_diagram: policyDiagram,
                    drgs: drgs
                })
            }
            const resp = await fetch(aaConfig?.deploy_policy, option)
            if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
            const result = await resp.json();
            // console.log("result:", result)
            updatePoliciesSelected[index].status = result?.status;
            updatePoliciesSelected[index].deployed_at = result?.timestamp;
            updatePoliciesSelected[index].error = result?.error;

            //when success then delete selection index 
            policySelectionIndex.ids.delete(index);

            setUpdatePolicies(true);
            setPoliciesSelected(updatePoliciesSelected);
        }
        setProcessing(false)
    }

    function CustomToolbar(props) {

        return (
            <GridToolbarContainer {...props} className="mt-2 ml-2">
                <GridToolbarQuickFilter variant="outlined" size="small" />
            </GridToolbarContainer>
        );
    }

    return (
        <Dialog
            maxWidth={"lg"}
            open={open}
        >
            <DialogTitle className='flex justify-between items-center' sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.white.main, paddingY: 1, paddingX: 2 }}>
                <Typography variant='subtitle2' component="span">Add Policies</Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        padding: 0,
                        color: theme.palette.white.main,
                    })}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ minWidth: 800, p: 0 }}>
                <TabContext value={tabSeleted}>
                    <TabPanel value="project" sx={{ padding: 0 }}>
                        <div className='animate-fade-right flex flex-col'>
                            <div className='flex-none py-6 px-5'>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6'>
                                        Choose Project
                                    </Typography>
                                </Breadcrumbs>
                                <Typography variant='subtitle2' color='textSecondary'>Choose Project you want to deploy.</Typography>
                            </div>
                            <div className='flex-grow w-full overflow-auto'>
                                <div className='grid gap-2 pb-4 px-5'>
                                    {loading ? (
                                        <Skeleton variant="rectangular" animation="wave" width={"100%"} height={60} className='rounded-md' />
                                    )
                                        : projects.length > 0 ?
                                            projects.map((project, idx) =>
                                                <div key={idx} onClick={() => handleOnSelectProject(project)} className={`flex justify-between w-full bg-white h-16 px-4 border border-gray-200 hover:bg-neutral-50 cursor-pointer rounded`}>
                                                    <Stack direction="row" spacing={2}>
                                                        <div className='h-full content-evenly'>
                                                            <Typography variant='body1'>{project.project_name}</Typography>
                                                            <Typography variant='subtitle2' color='textSecondary'>{project.description}</Typography>
                                                        </div>
                                                    </Stack>
                                                    <div className='h-full content-evenly'>
                                                        <NavigateNextIcon color="primary" fontSize="small" />
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                <div className='flex items-center justify-center w-full h-16 bg-gray-500 bg-opacity-20 rounded-md' >
                                                    <Typography color='textSecondary'>Project not available.</Typography>
                                                </div>
                                            )

                                    }
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value="policy" sx={{ padding: 0 }}>
                        <div className='animate-fade-right flex flex-col min-h-[500px]'>
                            <div className='flex-none py-6 px-5'>
                                <div className='flex justify-between items-center'>
                                    <div className='h-full content-evenly'>
                                        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                                            <Typography className='hover: cursor-pointer' sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6' onClick={() => setTabSeleted("project")}>
                                                Choose Project
                                            </Typography>
                                            <Typography color="primary" sx={{ display: 'flex', alignItems: 'center' }} variant='h6'>
                                                {projectSelected?.project_name}
                                            </Typography>
                                        </Breadcrumbs>
                                        <Typography variant='subtitle2' color='textSecondary'>Choose Policies you want to deploy.</Typography>
                                    </div>
                                    <div className='h-full content-evenly'>
                                        <Button variant="contained" onClick={handleOnChoosePolicies} disabled={policySelectionIndex.ids.size === 0}>Choose</Button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-grow w-full min-h-[400]'>
                                <DataGridPremium
                                    // apiRef={apiRef}
                                    isRowSelectable={(params) => params.row.status !== "Deployed"}
                                    loading={loading}
                                    rows={policies}
                                    columns={columns}
                                    checkboxSelection
                                    disableRowSelectionOnClick
                                    hideFooter
                                    slots={{ loadingOverlay: LinearProgress, toolbar: CustomToolbar }}
                                    sx={{
                                        height: 500,
                                        borderRadius: 0
                                    }}
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setPolicySelectionIndex(newRowSelectionModel);
                                    }}
                                    rowSelectionModel={policySelectionIndex}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value="deployer" sx={{ padding: 0 }}>
                        <div className='animate-fade-right flex flex-col min-h-[500px]'>
                            <div className='flex-none py-6 px-5'>
                                <div className='flex justify-between items-center'>
                                    <div className='h-full content-evenly'>
                                        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                                            <Typography className='hover: cursor-pointer' sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6' onClick={() => !processing ? setTabSeleted("project") : undefined}>
                                                Choose Project
                                            </Typography>
                                            <Typography className='hover: cursor-pointer' sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6' onClick={() => !processing ? setTabSeleted("policy") : undefined}>
                                                {projectSelected?.project_name}
                                            </Typography>
                                            <Typography color="primary" sx={{ display: 'flex', alignItems: 'center' }} variant='h6'>
                                                Deployer
                                            </Typography>
                                        </Breadcrumbs>
                                        <Typography variant='subtitle2' color='textSecondary'>You deploying the policy to <span className='font-semibold'>AA: {aaConfig?.name}.</span></Typography>
                                    </div>
                                    <div className='h-full content-evenly'>
                                        {policiesSelected.some((item) => item.status !== "success") && <Button variant="contained" sx={{ width: 150 }} color='success' onClick={!processing ? handleOnDeploy : undefined}>{processing ? <CircularProgress color='inherit' size={24} /> : "Deploy Policies"}</Button>}
                                    </div>
                                </div>
                            </div>
                            <div className='flex-1 w-full overflow-auto'>
                                <div className='grid gap-2 pb-4 px-5'>
                                    {loading ? (
                                        <Skeleton variant="rectangular" animation="wave" width={"100%"} height={60} className='rounded-md' />
                                    )
                                        :
                                        policiesSelected.map((item, idx) =>
                                            <div key={idx} className={`flex justify-between w-full bg-neutral-50 h-16 px-4 border border-gray-200 rounded-md`}>
                                                <Stack direction="row" spacing={2}>
                                                    <div className='h-full content-evenly'>
                                                        <Typography variant='body1'>{item.policy.policy_diagram_name}</Typography>
                                                        <Typography variant='caption' color='textSecondary'>{item.policy.policy_diagram_id}</Typography>
                                                    </div>
                                                </Stack>
                                                <div className='flex items-center justify-center h-full'>
                                                    {item?.status ? item.status === "processing" ? (
                                                        <CircularProgress size={24} />
                                                    ) : (
                                                        <div className='flex gap-4 justify-center, items-center'>
                                                            {item?.error ? (
                                                                <>
                                                                    <Typography variant='body2' component="span" color='error'>{item.error}</Typography>
                                                                    <ErrorIcon color='error' />
                                                                </>
                                                            )
                                                                : (
                                                                    <>
                                                                        <Typography variant='body2' component="span" color='success'>deployed at: {dayjs(item.deployed_at).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                                                                        <CheckCircleIcon color='success' />
                                                                    </>
                                                                )}

                                                        </div>
                                                    ) : <></>}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </TabContext>
            </DialogContent>
        </Dialog>
    );
}
